import { TicketsPage } from './../index';
import { AuthService } from './../../../../providers/auth-service';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, DateTime } from 'ionic-angular';
import { SummaryServiceProvider } from '../../../../providers/wh/summary-service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'ticket-add-page',
    templateUrl: 'add.html',
    providers: [SummaryServiceProvider]
})
export class TicketAddPage {


    header_data: any;
    public avl_rules_input: any;
    public ticket_data: any;
    public department_list:any;
    public priority_list:any;
    public tags_list:any;
    public checkedList:any;
    public today:any;

    constructor(
            private nav: NavController,
         public datepipe: DatePipe,
         public navParams: NavParams,
         public summaryService: SummaryServiceProvider,
         private auth: AuthService,
         public loadingCtrl: LoadingController){
        this.header_data = { ismenu: true, ishome: false, title: "Create Ticket", parentReloadData: d => { } };
        // this.datepipe.transform(this.start_time, 'yyyy-MM-dd')
        this.ticket_data={
            "title":"",
            "description":"",
            "deadline_date":new Date().toISOString(),
            "department":"OPERATION",
            "priority":"NORMAL",
            "tags":""
         }
         if(this.navParams.get('text'))
         {
            this.ticket_data.title=this.navParams.get('text');
         }

         if(this.navParams.get('description'))
         {
            this.ticket_data.description=this.navParams.get('description');
         }
         
         this.checkedList=[];
         this.department_list =this.auth.get_filers_items('ticketDepartment','id','value');
         this.priority_list =this.auth.get_filers_items('ticketPriority','id','value');
         this.tags_list=this.auth.get_item('tagsData');
    }


    checked(driverId, event) {
        if (event.checked) {
            this.checkedList.push(driverId);
        }
        else {
            this.checkedList.splice(this.checkedList.indexOf(driverId), 1);
        }
    }


    createTicketSubmit()
    {
        this.ticket_data.deadline_date=this.datepipe.transform(this.ticket_data.deadline_date, 'yyyy-MM-dd')+' 23:59:59';
        this.ticket_data.tags=this.checkedList;

        this.summaryService.post_data('ticket',this.ticket_data).then(() =>{
            alert('created');
            this.nav.setRoot(TicketsPage);


        })

    }




}


// WEBPACK FOOTER //
// ./src/pages/backoffice/tickets/add/add.ts